import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./bullet-editor.css";

export default function BulletEditor({ value, setValue, placeholder }) {

  useEffect(() => {
    if(value === "") {
      setBulletMode(true);
    }else if (value && value.includes("<ul>") && value.includes("<li>")) {
      setBulletMode(true);
    } else {
      setBulletMode(false);
    }
  }, [value]);


  const [bulletMode, setBulletMode] = useState(true);
  const quillRef = useRef(null);

  const toggleBulletMode = () => {
    setBulletMode(true);
    const editor = quillRef.current.getEditor();
    // Format all lines to bullet
    const length = editor.getLength();
    editor.formatLine(0, length, { list: "bullet" });
  };

  const toggleNormalMode = () => {
    setBulletMode(false);
    const editor = quillRef.current.getEditor();
    // Format all lines to normal
    const length = editor.getLength();
    editor.formatLine(0, length, { list: false });
  };

  useEffect(() => {
    const editor = quillRef.current.getEditor();
    const quill = editor;

    const handleKeyDown = (e) => {

      const selection = quill.getSelection();
      if (!selection) return;

      const [line, offset] = quill.getLine(selection.index);

      // Prevent backspace from removing bullet in bulletMode
      if (e.key === "Backspace" && bulletMode) {
        const formats = quill.getFormat(selection);
        if (formats.list === "bullet" && offset === 0) {
          e.preventDefault();
        }
      }

      // Force bullets in bulletMode
      if (e.key === "Enter" && bulletMode) {
        setTimeout(() => {
          const newSelection = quill.getSelection();
          if (newSelection) {
            quill.formatLine(newSelection.index, 1, { list: "bullet" });
          }
        }, 0);
      }
    };

    const editorEl = quill.root;
    // editorEl.addEventListener("keydown", handleKeyDown);
    return () => editorEl.removeEventListener("keydown", handleKeyDown);
  }, [bulletMode]);

  return (
    <div className="border rounded-2 w-full bg-light">

        <div className="d-flex">
          <button
            className={`btn btn-sm ${
              bulletMode ? "text-green" : "bg-gray-200"
            }`}
            onClick={toggleBulletMode}
          >
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.75 1C3.75 0.801088 3.82902 0.610322 3.96967 0.46967C4.11032 0.329018 4.30109 0.25 4.5 0.25H12.5C12.6989 0.25 12.8897 0.329018 13.0303 0.46967C13.171 0.610322 13.25 0.801088 13.25 1C13.25 1.19891 13.171 1.38968 13.0303 1.53033C12.8897 1.67098 12.6989 1.75 12.5 1.75H4.5C4.30109 1.75 4.11032 1.67098 3.96967 1.53033C3.82902 1.38968 3.75 1.19891 3.75 1ZM12.5 4.25H4.5C4.30109 4.25 4.11032 4.32902 3.96967 4.46967C3.82902 4.61032 3.75 4.80109 3.75 5C3.75 5.19891 3.82902 5.38968 3.96967 5.53033C4.11032 5.67098 4.30109 5.75 4.5 5.75H12.5C12.6989 5.75 12.8897 5.67098 13.0303 5.53033C13.171 5.38968 13.25 5.19891 13.25 5C13.25 4.80109 13.171 4.61032 13.0303 4.46967C12.8897 4.32902 12.6989 4.25 12.5 4.25ZM12.5 8.25H4.5C4.30109 8.25 4.11032 8.32902 3.96967 8.46967C3.82902 8.61032 3.75 8.80109 3.75 9C3.75 9.19891 3.82902 9.38968 3.96967 9.53033C4.11032 9.67098 4.30109 9.75 4.5 9.75H12.5C12.6989 9.75 12.8897 9.67098 13.0303 9.53033C13.171 9.38968 13.25 9.19891 13.25 9C13.25 8.80109 13.171 8.61032 13.0303 8.46967C12.8897 8.32902 12.6989 8.25 12.5 8.25ZM1.75 4C1.55222 4 1.35888 4.05865 1.19443 4.16853C1.02998 4.27841 0.901809 4.43459 0.826121 4.61732C0.750433 4.80004 0.73063 5.00111 0.769215 5.19509C0.8078 5.38907 0.903041 5.56725 1.04289 5.70711C1.18275 5.84696 1.36093 5.9422 1.55491 5.98079C1.74889 6.01937 1.94996 5.99957 2.13268 5.92388C2.31541 5.84819 2.47159 5.72002 2.58147 5.55557C2.69135 5.39112 2.75 5.19778 2.75 5C2.75 4.73478 2.64464 4.48043 2.45711 4.29289C2.26957 4.10536 2.01522 4 1.75 4ZM1.75 0C1.55222 0 1.35888 0.0586491 1.19443 0.16853C1.02998 0.278412 0.901809 0.43459 0.826121 0.617316C0.750433 0.800043 0.73063 1.00111 0.769215 1.19509C0.8078 1.38907 0.903041 1.56725 1.04289 1.70711C1.18275 1.84696 1.36093 1.9422 1.55491 1.98079C1.74889 2.01937 1.94996 1.99957 2.13268 1.92388C2.31541 1.84819 2.47159 1.72002 2.58147 1.55557C2.69135 1.39112 2.75 1.19778 2.75 1C2.75 0.734784 2.64464 0.48043 2.45711 0.292893C2.26957 0.105357 2.01522 0 1.75 0ZM1.75 8C1.55222 8 1.35888 8.05865 1.19443 8.16853C1.02998 8.27841 0.901809 8.43459 0.826121 8.61732C0.750433 8.80004 0.73063 9.00111 0.769215 9.19509C0.8078 9.38907 0.903041 9.56725 1.04289 9.70711C1.18275 9.84696 1.36093 9.9422 1.55491 9.98079C1.74889 10.0194 1.94996 9.99957 2.13268 9.92388C2.31541 9.84819 2.47159 9.72002 2.58147 9.55557C2.69135 9.39112 2.75 9.19778 2.75 9C2.75 8.73478 2.64464 8.48043 2.45711 8.29289C2.26957 8.10536 2.01522 8 1.75 8Z"
                fill={bulletMode ? "#307EFF" : "#3F3F3F"}
              />
            </svg>
          </button>
          <button
            className={`btn btn-sm ${
              !bulletMode ? "text-green" : "bg-gray-200"
            }`}
            onClick={toggleNormalMode}
          >
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.25 4.79297C13.25 4.99188 13.171 5.18265 13.0303 5.3233C12.8897 5.46395 12.6989 5.54297 12.5 5.54297H1.5C1.30109 5.54297 1.11032 5.46395 0.96967 5.3233C0.829018 5.18265 0.75 4.99188 0.75 4.79297C0.75 4.59406 0.829018 4.40329 0.96967 4.26264C1.11032 4.12199 1.30109 4.04297 1.5 4.04297H12.5C12.6989 4.04297 12.8897 4.12199 13.0303 4.26264C13.171 4.40329 13.25 4.59406 13.25 4.79297ZM1.5 1.54297H12.5C12.6989 1.54297 12.8897 1.46395 13.0303 1.3233C13.171 1.18265 13.25 0.991881 13.25 0.792969C13.25 0.594056 13.171 0.403291 13.0303 0.262639C12.8897 0.121986 12.6989 0.0429688 12.5 0.0429688H1.5C1.30109 0.0429688 1.11032 0.121986 0.96967 0.262639C0.829018 0.403291 0.75 0.594056 0.75 0.792969C0.75 0.991881 0.829018 1.18265 0.96967 1.3233C1.11032 1.46395 1.30109 1.54297 1.5 1.54297ZM12.5 8.04297H1.5C1.30109 8.04297 1.11032 8.12199 0.96967 8.26264C0.829018 8.40329 0.75 8.59406 0.75 8.79297C0.75 8.99188 0.829018 9.18265 0.96967 9.3233C1.11032 9.46395 1.30109 9.54297 1.5 9.54297H12.5C12.6989 9.54297 12.8897 9.46395 13.0303 9.3233C13.171 9.18265 13.25 8.99188 13.25 8.79297C13.25 8.59406 13.171 8.40329 13.0303 8.26264C12.8897 8.12199 12.6989 8.04297 12.5 8.04297Z"
                fill={!bulletMode ? "#307EFF" : "#3F3F3F"}
              />
            </svg>
          </button>
        </div>

        <div className="quill-wrapper">
            <ReactQuill
            ref={quillRef}
            value={value}
            onChange={setValue}
            modules={{ toolbar: false }}
            placeholder={placeholder??''}
            />
        </div>
    </div>
  );
}
